import { RoutePlanProposedShipment } from './RoutePlanProposedShipment';
import { RoutePlanStatus } from './RoutePlanStatus';

/** Payload of `GET shipment-planning/route-plan/{id}/builder` — a saved draft loaded back for editing. */
export class RoutePlanBuilderView {
  proposedShipments: RoutePlanProposedShipment[] = [];
  /** Persisted status of the plan, used to gate read-only mode. */
  status: RoutePlanStatus = RoutePlanStatus.DRAFT;
  /** Live (committed) shipment count; > 0 means the plan opens read-only. */
  shipmentCount = 0;

  constructor(opts?: Partial<RoutePlanBuilderView>) {
    if (opts?.proposedShipments != null) {
      this.proposedShipments = opts.proposedShipments.map(
        (s) => new RoutePlanProposedShipment(s),
      );
    }
    if (opts?.status != null) {
      this.status = opts.status;
    }
    if (opts?.shipmentCount != null) {
      this.shipmentCount = opts.shipmentCount;
    }
  }
}
